
<div class="cp-copy">
  <div v-if="isShare" class="title"></div>
  <div v-if="isShare" class="desc share">召集<span style="color: #990000">1位</span>兄弟，增加<span style="color: #990000">1次</span>抽奖机会</div>
  <div v-if="isDownload" class="desc">请在您的手机浏览器中打开此链接进行下载</div>
  <div v-if="isHome" class="desc">若您未安装微信，请下载微信后打开此链接参与活动</div>
  <input type="text" class="input" :class="{share: isShare}" v-model="copy" disabled>
  <div
    v-clipboard:copy="copy"
    v-clipboard:success="onCopy"
    v-clipboard:error="onError"
    class="button"
  ></div>
  <Close v-if="!isHome" is-mobile @close="handleClose" class="close"></Close>
</div>
